import { gql } from '@apollo/client'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useParentState = () => React.useContext(Context)
export const useParent = () => useParentState()?.serviceOrder

const QUERY = gql`
  query ServiceOrder($id: ID) {
    serviceOrder(id: $id, filter: { ignoreSegments: true }) {
      id
      yearlyId
      address {
        search
        complement
      }
      place {
        id
        name
        resume
      }
      checklist {
        id
        name
      }
    }
  }
`

const ParentsLoader = ({ children }) => {
  const { initialState } = useModalData() || {}
  const parentId = initialState?.parentId
  const { data, ...state } = useQuery(QUERY, {
    skip: !parentId,
    variables: { id: parentId },
    client: serviceOrdersClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ParentsLoader
